import { Plus } from 'lucide-react';
import { Button } from './Button';

export default function EmptyState({ title = 'Nenhum registro encontrado', description, onCreate }: { title?: string; description?: string; onCreate?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-slate-500">
      <p className="text-sm font-medium mb-1">{title}</p>
      {description && <p className="text-xs mb-4 text-slate-400">{description}</p>}
      {onCreate && (
        <Button onClick={onCreate} size="sm">
          <Plus className="h-4 w-4 mr-1" />
          Criar
        </Button>
      )}
    </div>
  );
}
